// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Throttle$Showside from "./Throttle.bs.js";
import * as WebapiUtils$Showside from "./WebapiUtils.bs.js";
function useWindow(enabledOpt, param) {
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var match = Throttle$Showside.use(30, true, function (param) {
    return Curry._1(WebapiUtils$Showside.$$Window.scrollY, undefined);
  });
  var setScrollPosition = match[1];
  var onScroll = function (e) {
    Curry._1(setScrollPosition, function (param) {
      return Curry._1(WebapiUtils$Showside.$$Window.scrollY, undefined);
    });
  };
  React.useEffect(function () {
    if (enabled) {
      window.addEventListener("scroll", onScroll, {
        capture: false,
        passive: true,
        once: false
      });
    }
    return function (param) {
      window.removeEventListener("scroll", onScroll, {
        capture: false,
        passive: true
      });
    };
  }, [enabled]);
  return match[0];
}
export { useWindow };
/* react Not a pure module */